<template>
<div id="create-provider">
  <h2>
    Edit
    <router-link
      :to="{
        name: 'provider',
        params: {
          providerId: providerId
        }
      }"
    >
      Provider #{{ providerId }}
    </router-link>
  </h2>

  <provider-nav
    :providerId="providerId"
  />

  <provider-form
    :providerId="providerId"
  ></provider-form>
</div>
</template>

<script>
import ProviderForm from '@/components/ProviderForm'
import ProviderNav from '@/components/ProviderNav'

export default {
  data () {
    return {}
  },

  components: {
    'provider-form': ProviderForm,
    'provider-nav': ProviderNav
  },

  props: ['providerId'],

  methods: {
    processErrors (resp) {
      this.$parent.processErrors(resp)
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/ProviderEdit.vue